import { useCallback } from 'react';
import { DEFAULT_ERROR_MESSAGE } from 'config/api';
import { useAuthPage } from '@features/auth/useAuthPage';
import useModalActions from './useModalAction';
import { APIError } from '@models/index';

const useSaveFileToPC = () => {
  const{ isElectron } = useAuthPage();
  const {
    successAction,
    errorAction,
  } = useModalActions();

  const saveFileToPC = useCallback(
    async (fileName: string, blob: Blob) => {
      try {
        if (isElectron) {
          const arrayBuffer = await blob.arrayBuffer();
          const filePath: string = await window.electron.ipcRenderer.saveFile(
            arrayBuffer,
            fileName,
          );
          if (!filePath || filePath.length === 0) {
            throw new Error(
              'The file save operation was canceled. Please try saving the file again.',
            );
          }
        } else {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
        await successAction('Please check your downloads.');
      } catch (e) {
        const error = e as APIError;
        await errorAction(error, error.message ?? DEFAULT_ERROR_MESSAGE);
      }
    },
    [isElectron, open],
  );

  return saveFileToPC;
};

export default useSaveFileToPC;
